<template>
  <transition
    name="slide-transition"
    mode="out-in"
    @enter="enter"
    @leave="leave"
  >
    <slot />
  </transition>
</template>

<script type="text/ecmascript-6">
import Velocity from 'velocity-animate'

export default {
  name: 'TransitionSlide',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    enter: function (el, done) {
      el.style.display = 'none'
      Velocity(el, 'slideDown', { duration: 350, easing: 'ease-in', complete: done })
    },
    enterCancelled: function (el) {
      Velocity(el, 'stop')
    },
    leave: function (el, done) {
      Velocity(el, 'slideUp', { duration: 350, easing: 'ease-out', complete: done })
    },
    leaveCancelled: function (el) {
      Velocity(el, 'stop')
    }
  }
}
</script>
